<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit frequently asked question') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteFaqModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/custom-pages">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateFAQ">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('FAQ information') }}
              </h3>
              <p class="form-description-text">{{ $t('Update FAQ information') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="question">{{ $t('Question') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Question')" class="form-input" id="question" required v-model="faq.question" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="answer">{{ $t('Answer') }}</label>
                  <textarea
                    :placeholder="$t('Answer')"
                    class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    id="answer"
                    required
                    rows="5"
                    v-model="faq.answer"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/faq">{{ $t('Close') }}</router-link>
              <button class="btn btn-green shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <faq-delete-model :show="deleteFaqModal" @cancelled="deleteFaqModal = false" @confirmed="deleteFaq">
      <template #title>{{ $t('Delete FAQ') }}</template>
      {{ $t('Are you sure you want to delete the FAQ?') }}
      {{ $t('All data will be permanently removed') }}.
    </faq-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  components: {
    FaqDeleteModel: confirmationModel,
  },
  metaInfo() {
    return {
      title: this.$i18n.t('Edit FAQ'),
    };
  },
  data() {
    return {
      loading: false,
      deleteFaqModal: false,
      faq: {
        question: null,
        answer: null,
      },
    };
  },
  mounted() {
    this.getFAQ();
  },
  methods: {
    updateFAQ() {
      this.loading = true;
      axios
        .put(route('faq.update', this.$route.params.id), this.faq)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getFAQ() {
      this.loading = true;
      axios
        .get(route('faq.show', this.$route.params.id))
        .then((response) => {
          this.faq = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteFaq() {
      axios
        .delete(route('faq.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/faq');
        })
        .catch(() => {
          this.deleteFaqModal = false;
        });
    },
  },
};
</script>
